<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    大芬站<br>
站点介绍<br>
大芬站位于深圳市龙岗区布吉街道龙岗大道上方。西南侧（A出入口）星都里、油画村、东大街、沃尔玛、桂芳园、中房怡芬花园、中翠花园；东北侧（C出入口）怡康家园、康达尔花园、倚龙华庭等。大芬站以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:04	23:31	3号线	2分15-20秒	4分30秒<br>
双龙	06:18	23:41	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:06	23:31	3号线	3分15秒	5分钟<br>
双龙	06:26	23:41	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:06	00:31	3号线	3分15秒	5分钟<br>
双龙	06:26	00:41	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A1出入口:<br>
龙岗大道（东）、大芬油画村、中房怡芬、星都豪庭、沃尔玛<br><br>
A2出入口:<br>
布吉东大街、中翠花园、桂芳园、布吉高级中学<br><br>
C出入口:<br>
龙岗大道（西）、怡康家园、桔子坑、康达尔花园、和谐家园、友联花园、知春里<br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 大芬地铁站1<br>
8、322,357,366,977，M190,M239,M358， M485,M585,高峰专线31号<br><br>
A1出入口:<br>
公交站名： 大芬地铁站2<br>
M139,M180,M192,M194,M233, M273、M283,M300,M363 ,M415、M508、M588、M589，深惠3A线<br><br>
C出入口:<br>
公交站名： 大芬地铁站1<br>
8、322,357,366,977，M150,M190,M239,M273,M283,M358， M485,M585、高峰专/31号<br><br>
C出入口:<br>
公交站名： 大芬地铁站2<br>
M139,M180,M192,M194,M233, M283,M300,M363 ,M395,M508,M565，M588、M589深惠3A线<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>